import Categories from './Categories';

const CategoriesBar = () => (
  <div className="flex min-w-full flex-row items-center justify-center">
    <div className="min-h-[77px] w-full max-w-screen-2xl border-b">
      <Categories />
    </div>
  </div>
);

export default CategoriesBar;
